import { BRANCH_API } from "shared/constants/api-endpoint";
import { ScheduleSettingModel } from "shared/models/schedule-setting-model";
import { apiClient } from "shared/plugins/http-service";

export const getBranchScheduleSetting = async (branchId: number) => {
  return await apiClient.getHttp<ScheduleSettingModel>(
    `${BRANCH_API}/${branchId}/schedule_settings`
  );
};

export const updateBranchScheduleSetting = async (
  branchId: number,
  model: ScheduleSettingModel
) => {
  const response = await apiClient.putHttp(
    `${BRANCH_API}/${branchId}/schedule_settings`,
    model
  );
  return response;
};
